export const downloadFile = (data: any, fileName: string, fileType: string) => {
  const blob = new Blob([data], { type: fileType });
  const _url = window.URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = _url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);

  window.URL.revokeObjectURL(_url);
};
